// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.afterLoginNavbar_afterLoginNavbar__oSSFU {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 3;
  background-color: #fff;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.0509803922);
  height: 64px;
  max-height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  transition: all 0.2s ease-in-out;
}
.afterLoginNavbar_afterLoginNavbar__oSSFU::after {
  content: "";
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 1px;
  background-color: #dfe4eb;
  left: 0;
}
.afterLoginNavbar_afterLoginNavbar__oSSFU .afterLoginNavbar_navbarWrp__JNrg4 {
  width: 100%;
}
.afterLoginNavbar_afterLoginNavbar__oSSFU .afterLoginNavbar_navbarWrp__JNrg4 .afterLoginNavbar_breadcrumbs__cGAnG {
  padding-left: 16px;
  position: relative;
}
.afterLoginNavbar_afterLoginNavbar__oSSFU .afterLoginNavbar_navbarWrp__JNrg4 .afterLoginNavbar_breadcrumbs__cGAnG::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 2px;
  height: 100%;
  background-color: #dfe4eb;
}
.afterLoginNavbar_afterLoginNavbar__oSSFU .afterLoginNavbar_navbarWrp__JNrg4 .afterLoginNavbar_panelIcon__\\+jYkg {
  cursor: pointer;
  width: 28px;
  height: 28px;
  padding: 6px 6px 6px 0;
  min-width: unset;
  margin-right: 8px;
  flex-shrink: 0;
}
.afterLoginNavbar_afterLoginNavbar__oSSFU .afterLoginNavbar_navbarWrp__JNrg4 .afterLoginNavbar_panelIcon__\\+jYkg img,
.afterLoginNavbar_afterLoginNavbar__oSSFU .afterLoginNavbar_navbarWrp__JNrg4 .afterLoginNavbar_panelIcon__\\+jYkg svg {
  width: 100%;
  height: 100%;
  display: block;
}
.afterLoginNavbar_afterLoginNavbar__oSSFU .afterLoginNavbar_navbarWrp__JNrg4 .afterLoginNavbar_navLeft__5YHiV {
  flex: 1 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-right: 15px;
}
.afterLoginNavbar_afterLoginNavbar__oSSFU .afterLoginNavbar_navbarWrp__JNrg4 .afterLoginNavbar_navRight__bmFBv .afterLoginNavbar_rightNavButtons__Ew-E- {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}
.afterLoginNavbar_afterLoginNavbar__oSSFU .afterLoginNavbar_navbarWrp__JNrg4 .afterLoginNavbar_navRight__bmFBv .afterLoginNavbar_rightNavButtons__Ew-E- li {
  display: flex;
  align-items: center;
  justify-content: center;
}

.afterLoginNavbar_notificationDropdown__vJMYf .afterLoginNavbar_notificationIcon__40q85 {
  width: 20px;
  height: 20px;
  cursor: pointer;
  padding: 0;
}
.afterLoginNavbar_notificationDropdown__vJMYf .afterLoginNavbar_notificationIcon__40q85 img,
.afterLoginNavbar_notificationDropdown__vJMYf .afterLoginNavbar_notificationIcon__40q85 svg {
  width: 100%;
  height: 100%;
  display: block;
}
.afterLoginNavbar_notificationDropdown__vJMYf .afterLoginNavbar_notificationImg__vglmx {
  width: 20px;
  height: 20px;
  display: block;
}

.afterLoginNavbar_menuContainer__v0iv2 .afterLoginNavbar_menuHeader__tDlyX {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.afterLoginNavbar_menuContainer__v0iv2 .afterLoginNavbar_menuHeader__tDlyX h5 {
  font: var(--body-font-one);
  font-weight: 600;
  color: var(--primary-Text);
}
.afterLoginNavbar_menuContainer__v0iv2 .afterLoginNavbar_menuHeader__tDlyX h6 {
  font: var(--body-font-four);
  font-weight: 400;
  color: var(--secondary-Text);
  cursor: pointer;
}
.afterLoginNavbar_menuContainer__v0iv2 .afterLoginNavbar_menuBody__mKHvO .afterLoginNavbar_menuItemCard__pMclr {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 0 8px;
  border: 1px solid #DFE4EB;
  border-radius: 8px;
  padding: 8px 12px;
  width: 100%;
  overflow: hidden;
  transition: all 0.2s ease-in-out;
}
.afterLoginNavbar_menuContainer__v0iv2 .afterLoginNavbar_menuBody__mKHvO .afterLoginNavbar_menuItemCard__pMclr .afterLoginNavbar_menuIcon__vtcL7 {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--bg3);
  padding: 10px;
  flex-shrink: 0;
}
.afterLoginNavbar_menuContainer__v0iv2 .afterLoginNavbar_menuBody__mKHvO .afterLoginNavbar_menuItemCard__pMclr .afterLoginNavbar_menuIcon__vtcL7 img,
.afterLoginNavbar_menuContainer__v0iv2 .afterLoginNavbar_menuBody__mKHvO .afterLoginNavbar_menuItemCard__pMclr .afterLoginNavbar_menuIcon__vtcL7 svg {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.afterLoginNavbar_menuContainer__v0iv2 .afterLoginNavbar_menuBody__mKHvO .afterLoginNavbar_menuItemCard__pMclr .afterLoginNavbar_menuText__cswdJ {
  flex: 1 1;
  gap: 2px;
}
.afterLoginNavbar_menuContainer__v0iv2 .afterLoginNavbar_menuBody__mKHvO .afterLoginNavbar_menuItemCard__pMclr .afterLoginNavbar_menuText__cswdJ .afterLoginNavbar_row__mZ0i4 {
  flex: 1 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.afterLoginNavbar_menuContainer__v0iv2 .afterLoginNavbar_menuBody__mKHvO .afterLoginNavbar_menuItemCard__pMclr .afterLoginNavbar_menuText__cswdJ h5 {
  font: var(--body-font-three);
  font-weight: 600;
  color: var(--primary-Text);
  white-space: normal;
}
.afterLoginNavbar_menuContainer__v0iv2 .afterLoginNavbar_menuBody__mKHvO .afterLoginNavbar_menuItemCard__pMclr .afterLoginNavbar_menuText__cswdJ .afterLoginNavbar_time__AZlS- {
  margin-left: 8px;
  font: var(--body-font-four);
  color: var(--secondary-Text);
  font-weight: 400;
}
.afterLoginNavbar_menuContainer__v0iv2 .afterLoginNavbar_menuBody__mKHvO .afterLoginNavbar_menuItemCard__pMclr .afterLoginNavbar_menuText__cswdJ .afterLoginNavbar_subheading__NxAM6 {
  width: 100%;
  font: var(--body-font-four);
  white-space: normal;
  color: var(--secondary-Text);
  margin-top: 2px;
}
.afterLoginNavbar_menuContainer__v0iv2 .afterLoginNavbar_menuBody__mKHvO .afterLoginNavbar_menuItemCard__pMclr:hover {
  background-color: var(--bg3);
  border-color: transparent;
}
.afterLoginNavbar_menuContainer__v0iv2 .afterLoginNavbar_menuBody__mKHvO .afterLoginNavbar_menuItemCard__pMclr:hover .afterLoginNavbar_menuIcon__vtcL7 {
  background-color: var(--white);
}
.afterLoginNavbar_menuContainer__v0iv2 .afterLoginNavbar_menuBody__mKHvO .afterLoginNavbar_menuItemCard__pMclr.afterLoginNavbar_unread__iDaNX {
  background-color: #F2F6F8;
  border: transparent;
}
.afterLoginNavbar_menuContainer__v0iv2 .afterLoginNavbar_menuBody__mKHvO .afterLoginNavbar_menuItemCard__pMclr.afterLoginNavbar_unread__iDaNX .afterLoginNavbar_menuIcon__vtcL7 {
  background-color: var(--white);
}
.afterLoginNavbar_menuContainer__v0iv2 .afterLoginNavbar_menuBody__mKHvO .afterLoginNavbar_menuItemCard__pMclr.afterLoginNavbar_unread__iDaNX .afterLoginNavbar_menuText__cswdJ h5 {
  font-weight: 600;
}
.afterLoginNavbar_menuContainer__v0iv2 .afterLoginNavbar_menuFooter__z4Zbu {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  cursor: pointer;
}
.afterLoginNavbar_menuContainer__v0iv2 .afterLoginNavbar_menuFooter__z4Zbu .afterLoginNavbar_viewAll__kgSEJ {
  font: var(--body-font-four);
  font-weight: 500;
  color: var(--primary-Text);
}

@media (max-width: 767px) {
  .afterLoginNavbar_afterLoginNavbar__oSSFU .afterLoginNavbar_navbarWrp__JNrg4 .afterLoginNavbar_navRight__bmFBv .afterLoginNavbar_rightNavButtons__Ew-E- li {
    width: 32px;
    height: 32px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/navbars/afterLoginNavbar.module.scss"],"names":[],"mappings":"AAAA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EAEA,UAAA;EACA,sBAAA;EACA,uDAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,gCAAA;AAAD;AAEC;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,OAAA;AAAF;AAGC;EACC,WAAA;AADF;AAGE;EACC,kBAAA;EACA,kBAAA;AADH;AAGG;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AADJ;AAKE;EACC,eAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAHH;AAKG;;EAEC,WAAA;EACA,YAAA;EACA,cAAA;AAHJ;AAOE;EACC,SAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;AALH;AASG;EACC,aAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AAPJ;AASI;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;AAPL;;AAeC;EACC,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AAZF;AAcE;;EAEC,WAAA;EACA,YAAA;EACA,cAAA;AAZH;AAgBC;EACC,WAAA;EACA,YAAA;EACA,cAAA;AAdF;;AAmBC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAhBF;AAkBE;EACC,0BAAA;EACA,gBAAA;EACA,0BAAA;AAhBH;AAmBE;EACC,2BAAA;EACA,gBAAA;EACA,4BAAA;EACA,eAAA;AAjBH;AAsBE;EACC,aAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,gCAAA;AApBH;AAsBG;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;EACA,aAAA;EACA,cAAA;AApBJ;AAsBI;;EAEC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AApBL;AAwBG;EACC,SAAA;EACA,QAAA;AAtBJ;AAwBI;EACC,SAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;AAtBL;AAyBI;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;AAvBL;AA0BI;EACC,gBAAA;EACA,2BAAA;EACA,4BAAA;EACA,gBAAA;AAxBL;AA2BI;EACC,WAAA;EACA,2BAAA;EACA,mBAAA;EACA,4BAAA;EACA,eAAA;AAzBL;AA6BG;EACC,4BAAA;EACA,yBAAA;AA3BJ;AA6BI;EACC,8BAAA;AA3BL;AA+BG;EAGC,yBAAA;EACA,mBAAA;AA/BJ;AAiCI;EACC,8BAAA;AA/BL;AAmCK;EACC,gBAAA;AAjCN;AAwCC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;AAtCF;AAwCE;EACC,2BAAA;EACA,gBAAA;EACA,0BAAA;AAtCH;;AA2CA;EAKK;IACC,WAAA;IACA,YAAA;EA5CJ;AACF","sourcesContent":[".afterLoginNavbar {\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\t// padding: 5px 0;\r\n\tz-index: 3;\r\n\tbackground-color: #fff;\r\n\tbox-shadow: 0px 1px 2px 0px #0000000d;\r\n\theight: 64px;\r\n\tmax-height: 64px;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\twidth: 100%;\r\n\ttransition: all 0.2s ease-in-out;\r\n\r\n\t&::after {\r\n\t\tcontent: '';\r\n\t\tposition: absolute;\r\n\t\tbottom: 0;\r\n\t\twidth: 100%;\r\n\t\theight: 1px;\r\n\t\tbackground-color: #dfe4eb;\r\n\t\tleft: 0;\r\n\t}\r\n\r\n\t.navbarWrp {\r\n\t\twidth: 100%;\r\n\r\n\t\t.breadcrumbs {\r\n\t\t\tpadding-left: 16px;\r\n\t\t\tposition: relative;\r\n\r\n\t\t\t&::before {\r\n\t\t\t\tcontent: '';\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\ttop: 0;\r\n\t\t\t\tleft: 0;\r\n\t\t\t\twidth: 2px;\r\n\t\t\t\theight: 100%;\r\n\t\t\t\tbackground-color: #dfe4eb;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.panelIcon {\r\n\t\t\tcursor: pointer;\r\n\t\t\twidth: 28px;\r\n\t\t\theight: 28px;\r\n\t\t\tpadding: 6px 6px 6px 0;\r\n\t\t\tmin-width: unset;\r\n\t\t\tmargin-right: 8px;\r\n\t\t\tflex-shrink: 0;\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\theight: 100%;\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.navLeft {\r\n\t\t\tflex: 1;\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: flex-start;\r\n\t\t\talign-items: center;\r\n\t\t\tpadding-right: 15px;\r\n\t\t}\r\n\r\n\t\t.navRight {\r\n\t\t\t.rightNavButtons {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tflex-wrap: wrap;\r\n\t\t\t\tjustify-content: flex-end;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 12px;\r\n\r\n\t\t\t\tli {\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tjustify-content: center;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.notificationDropdown {\r\n\t.notificationIcon {\r\n\t\twidth: 20px;\r\n\t\theight: 20px;\r\n\t\tcursor: pointer;\r\n\t\tpadding: 0;\r\n\r\n\t\timg,\r\n\t\tsvg {\r\n\t\t\twidth: 100%;\r\n\t\t\theight: 100%;\r\n\t\t\tdisplay: block;\r\n\t\t}\r\n\t}\r\n\r\n\t.notificationImg {\r\n\t\twidth: 20px;\r\n\t\theight: 20px;\r\n\t\tdisplay: block;\r\n\t}\r\n}\r\n\r\n.menuContainer {\r\n\t.menuHeader {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tgap: 8px;\r\n\t\tmargin-bottom: 12px;\r\n\r\n\t\th5 {\r\n\t\t\tfont: var(--body-font-one);\r\n\t\t\tfont-weight: 600;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t}\r\n\r\n\t\th6 {\r\n\t\t\tfont: var(--body-font-four);\r\n\t\t\tfont-weight: 400;\r\n\t\t\tcolor: var(--secondary-Text);\r\n\t\t\tcursor: pointer;\r\n\t\t}\r\n\t}\r\n\r\n\t.menuBody {\r\n\t\t.menuItemCard {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-wrap: wrap;\r\n\t\t\talign-items: flex-start;\r\n\t\t\tgap: 0 8px;\r\n\t\t\tborder: 1px solid #DFE4EB;\r\n\t\t\tborder-radius: 8px;\r\n\t\t\tpadding: 8px 12px;\r\n\t\t\twidth: 100%;\r\n\t\t\toverflow: hidden;\r\n\t\t\ttransition: all 0.2s ease-in-out;\r\n\r\n\t\t\t.menuIcon {\r\n\t\t\t\twidth: 40px;\r\n\t\t\t\theight: 40px;\r\n\t\t\t\tborder-radius: 50%;\r\n\t\t\t\tbackground-color: var(--bg3);\r\n\t\t\t\tpadding: 10px;\r\n\t\t\t\tflex-shrink: 0;\r\n\r\n\t\t\t\timg,\r\n\t\t\t\tsvg {\r\n\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\theight: 100%;\r\n\t\t\t\t\tobject-fit: contain;\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t.menuText {\r\n\t\t\t\tflex: 1;\r\n\t\t\t\tgap: 2px;\r\n\r\n\t\t\t\t.row {\r\n\t\t\t\t\tflex: 1;\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\tflex-wrap: wrap;\r\n\t\t\t\t\tjustify-content: space-between;\r\n\t\t\t\t}\r\n\r\n\t\t\t\th5 {\r\n\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\twhite-space: normal;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.time {\r\n\t\t\t\t\tmargin-left: 8px;\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.subheading {\r\n\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\twhite-space: normal;\r\n\t\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\t\tmargin-top: 2px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t&:hover {\r\n\t\t\t\tbackground-color: var(--bg3);\r\n\t\t\t\tborder-color: transparent;\r\n\r\n\t\t\t\t.menuIcon {\r\n\t\t\t\t\tbackground-color: var(--white);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t&.unread {\r\n\t\t\t\t// border-left-width: 5px;\r\n\t\t\t\t// border-color: var(--brand);\r\n\t\t\t\tbackground-color: #F2F6F8;\r\n\t\t\t\tborder: transparent;\r\n\r\n\t\t\t\t.menuIcon {\r\n\t\t\t\t\tbackground-color: var(--white);\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.menuText {\r\n\t\t\t\t\th5 {\r\n\t\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.menuFooter {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: center;\r\n\t\talign-items: center;\r\n\t\tgap: 8px;\r\n\t\tmargin-top: 12px;\r\n\t\tcursor: pointer;\r\n\r\n\t\t.viewAll {\r\n\t\t\tfont: var(--body-font-four);\r\n\t\t\tfont-weight: 500;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.afterLoginNavbar {\r\n\t\t.navbarWrp {\r\n\t\t\t.navRight {\r\n\t\t\t\t.rightNavButtons {\r\n\t\t\t\t\tli {\r\n\t\t\t\t\t\twidth: 32px;\r\n\t\t\t\t\t\theight: 32px;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"afterLoginNavbar": `afterLoginNavbar_afterLoginNavbar__oSSFU`,
	"navbarWrp": `afterLoginNavbar_navbarWrp__JNrg4`,
	"breadcrumbs": `afterLoginNavbar_breadcrumbs__cGAnG`,
	"panelIcon": `afterLoginNavbar_panelIcon__+jYkg`,
	"navLeft": `afterLoginNavbar_navLeft__5YHiV`,
	"navRight": `afterLoginNavbar_navRight__bmFBv`,
	"rightNavButtons": `afterLoginNavbar_rightNavButtons__Ew-E-`,
	"notificationDropdown": `afterLoginNavbar_notificationDropdown__vJMYf`,
	"notificationIcon": `afterLoginNavbar_notificationIcon__40q85`,
	"notificationImg": `afterLoginNavbar_notificationImg__vglmx`,
	"menuContainer": `afterLoginNavbar_menuContainer__v0iv2`,
	"menuHeader": `afterLoginNavbar_menuHeader__tDlyX`,
	"menuBody": `afterLoginNavbar_menuBody__mKHvO`,
	"menuItemCard": `afterLoginNavbar_menuItemCard__pMclr`,
	"menuIcon": `afterLoginNavbar_menuIcon__vtcL7`,
	"menuText": `afterLoginNavbar_menuText__cswdJ`,
	"row": `afterLoginNavbar_row__mZ0i4`,
	"time": `afterLoginNavbar_time__AZlS-`,
	"subheading": `afterLoginNavbar_subheading__NxAM6`,
	"unread": `afterLoginNavbar_unread__iDaNX`,
	"menuFooter": `afterLoginNavbar_menuFooter__z4Zbu`,
	"viewAll": `afterLoginNavbar_viewAll__kgSEJ`
};
export default ___CSS_LOADER_EXPORT___;
